import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  padding: 12px;
`;

export const EmojiWrapper = styled.div`
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -0.5px;
  padding: 12px;
`;

export const TitleText = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.5px;
`;
